var React = require('react');

function User (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0}),React.createElement("path",{"d":"M22.56,16.53a9.95,9.95,0,0,1-13.12,0A15,15,0,0,0,1,30a1,1,0,0,0,1,1H30a1,1,0,0,0,1-1A15,15,0,0,0,22.56,16.53Z","key":1}),React.createElement("circle",{"cx":"16","cy":"9","r":"8","key":2})]);
}

User.defaultProps = {"id":"user","height":"20","width":"20","viewBox":"0 0 32 32"};

module.exports = User;

User.default = User;
